import Query from '../../../components/Report';

const query = (country) => new Query('discover-stats-countries-chart', { country });

export default query;
